<div class="full-width-header header-style1 home8-style4">
  <main-menu></main-menu>
</div>
<!-- Main content Start -->
<div class="main-content">
  <div class="rs-breadcrumbs breadcrumbs-overlay">
    <div class="breadcrumbs-img">
      <img src="assets/images/breadcrumbs/2.jpg" alt="Breadcrumbs Image">
    </div>
    <div class="breadcrumbs-text white-color">
      <h1 class="page-title">SC &amp; ST Grievance Committee</h1>
      <ul>
        <li><a class="active" routerLink="/home">Home</a></li>
        <li>SC &amp; ST Grievance Committee</li>
      </ul>
    </div>
  </div>

  <div class="rs-inner-blog orange-color pt-100 pb-100 md-pt-70 md-pb-70 committee-section">
    <div class="container">
      <div class="row">
        <div class="col-lg-4 col-md-12 pr-50 md-pr-15">
          <div class="widget-area">
            <div class="widget-archives footer-widget mb-50">
              <h3 class="widget-title">Committees</h3>
              <ul>
                <li class="menu-item-has-children" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: false }">
                  <ul class="sub-menu">
                    <li routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"><a routerLink="/anti-ragging-committee">Anti Ragging Committee</a></li>
                    <li routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"><a routerLink="/grievance-reddressal-committee">Grievance Reddressal Committee</a></li>
                    <li routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"><a routerLink="/internal-complaints-committee">Internal Complaints Committee</a></li>
                    <li routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"><a routerLink="/sc-and-st-grievance-committee">SC &amp; ST Grievance Committee</a></li>
                    <li routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"><a routerLink="/internal-quality-assurance-committee">Internal Quality Assurance Committee</a></li>
                    <li routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"><a routerLink="/institution-industry-cell">Institution Industry Cell</a></li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="col-lg-8">
          <div class="committee-content-wrap">
            <h2 class="committee-main-title">SC &amp; ST Grievance Committee</h2>

            <p class="committee-paragraph">
              The SC / ST Cell are functioning since 02-07-2016 onwards to ensure the fulfillment of Reservation for
              SC / ST s in all matters. The institute has constituted an SC / ST Cell, which deals with the following
              activities:
            </p>

            <ol class="complaint-list">
              <li>SC/ST Boklet (prepared by TISS)</li>
              <li>Ministry of Social Justice and empowerment</li>
              <li>List of Resolutions for Backward Classes</li>
              <li>List of Resolutions for Scheduled Caste Welfare</li>
              <li>Hand Book for Scheduled Tribes</li>
              <li>Scholarships for Reserved students: Government of India</li>
              <li>Schemes: Government of India</li>
              <li>National Scheduled Castes Finance and Development Corporation</li>
            </ol>

            <p class="blog-table-wrap">
              <a href="/assets/college/Committees/SC&STGrievanceCommittee2024-25.pdf" target="_blank">SC &amp; ST Grievance Committee (click to view)</a>
            </p>

            <ol class="complaint-list">
              <li>Effective implementations of the Orders / Circulars / Guidelines issued by the Central /State / UGC in respect of Reservation</li>
              <li>To oversee and extend all possible education facilities like Hostels accommodation, Scholarships &amp; stipend to SC, ST students</li>
              <li>To provide up to date information statistics in reservation matters to the Central/State/ UGC</li>
              <li>Conduct of Grievance of Committee for SC, ST's.</li>
              <li>Organizing Dr. B. R. Ambedkar Birthday celebrations &amp; Anniversary Programmes.</li>
              <li>Special Coaching for competitive exams Civil Services (Prelims), Personality Development, Communication Skills etc</li>
            </ol>

            <p class="committee-paragraph committee-link-line">
              For more Information: <a href="http://www.aicte-india.org/adscell.php" target="_blank" rel="noopener noreferrer">http://www.aicte-india.org/adscell.php</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Newsletter section start -->
  <app-subscribe></app-subscribe>
  <!-- Newsletter section end -->
</div>
<!-- Main content End -->

